module.exports = __webpack_public_path__ + "static/img/HK-Android.cb2afd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HK-Android.png
// module id = h1IS
// module chunks = 4